// extracted by mini-css-extract-plugin
export default {"MobileScrollContainer":"MobileScrollContainer_MobileScrollContainer__Njg5Z"};